import { Stack } from 'src/viewLayer/components/DesignSystem';

import type { InfoPagePropsType } from '../types';
import InfoPageBanner from './InfoPageBanner';
import InfoPageImage from './InfoPageImage';
import InfoPageCourses from './InfoPageCourses';
import InfoPageDescription from './InfoPageDescription';
import InfoPageFootnote from './InfoPageFootnote';
import InfoPageFooter from './InfoPageFooter';
import './index.scss';
import {
  getContentBasedOnInput
} from 'src/viewLayer/components/nodes/PageNode/InfoPage/getContentBasedOnInput';
import { getUserResponseToQuestion } from 'src/viewLayer/components/nodes/PageNode/InfoPage/getUserResponseToQuestion';

export const InfoPage = ({
  variables,
  goToNextNode,
  userInput,
  options
}: InfoPagePropsType): JSX.Element => {
  let imageFromUserInput;
  let descriptionFromUserInput;
  let coursesFromUserInput;
  let contentIdFromUserInput;

  if (options?.getContentBasedOnInput) {
    const { image, description, courses, id: contentId } = getContentBasedOnInput(
      options.getContentBasedOnInput,
      getUserResponseToQuestion(userInput, variables.id)
    );
    const imageVersion: string =  image;

    imageFromUserInput = imageVersion;
    descriptionFromUserInput = description;
    coursesFromUserInput = courses;
    contentIdFromUserInput = contentId;
  }

  const {
    banner,
    button,
    courses: configCourses,
    description: configDescription,
    footnote,
    id: configId,
    image: configImage,
  } = variables;
  // the default node config will act as a backup if no userInput values are found
  const selectedImage = imageFromUserInput || configImage;
  const selectedDescription =  descriptionFromUserInput || configDescription;
  const selectedCourses = coursesFromUserInput || configCourses;
  const selectedContentId = contentIdFromUserInput || configId;

  return (
    <Stack
      id={`uat-info-${configId}`}
      className="InfoPage"
      gap={{ xxxsmall: 12, small: 10 }}
      align="spaceBetween"
      alignItems="center"
    >
      <Stack className="main-content" align="leading" alignItems="center" gap={56}>
        { banner && <InfoPageBanner banner={banner} />}
        { selectedImage && <InfoPageImage image={selectedImage} /> }
        { selectedCourses &&
          <InfoPageCourses courses={selectedCourses} id={selectedContentId} />
        }
        { selectedDescription && <InfoPageDescription description={selectedDescription} /> }
        { footnote && <InfoPageFootnote footnote={footnote} /> }
        <InfoPageFooter goToNextNode={ goToNextNode } buttonTranslationKey={ button?.key } pageType={ configId }/>
      </Stack>
    </Stack>
  );
};
